import TagManager, { TagManagerArgs } from 'react-gtm-module';

export function setupGTM() {
  const tagManagerArgs: TagManagerArgs = {
    gtmId: process.env.REACT_APP_GTM_ID ?? '',
  };

  TagManager.initialize(tagManagerArgs);
}
